import React, {useContext, useState, useEffect} from 'react';
import {AppStoreContext} from 'components/Mall/AppStore/AppStore.js'
import {ExceedApiContext} from 'containers/App/ExceedApi';
import {Page, Input, Button, AlertDialog, Toolbar, BottomToolbar} from 'react-onsenui';
import {useHistory} from "react-router";
import {SESSION_STATUS} from "components/Mall/AppStore/AppStore";
import logo from 'containers/Main/mediumLogo.png';
import jwt_decode from "jwt-decode";

// prod/test client id
const EXCEED_GOOGLE_CLIENT_ID = '746133502932-n2i3hhl00ipkvj2uf5b7ir0r2d38ilgn.apps.googleusercontent.com';
// dev client id
// const EXCEED_GOOGLE_CLIENT_ID = '102821117185-n63f8vft10bvtioen911bdegeabdg46m.apps.googleusercontent.com';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    const ExceedApi = useContext(ExceedApiContext);
    const AppStore = useContext(AppStoreContext);

    const [userName, setUserName] = useState(undefined);
    const [password, setPassword] = useState(undefined);
    const [loginDisabled, setLoginDisabled] = useState(false);
    const [errors, setErrors] = useState([]);

    const [gsiScriptLoaded, setGsiScriptLoaded] = useState(false);

    let history = useHistory();

    const initializeGsi = () => {
        if (!window.google || gsiScriptLoaded) {
            return;
        }

        setGsiScriptLoaded(true);
        window.google.accounts.id.initialize({
            client_id: EXCEED_GOOGLE_CLIENT_ID,
            callback: handleGoogleSignIn,
        });

        window.google.accounts.id.renderButton(document.getElementById("google_sign_in_btn"), {
            type: "standard",
            shape: "rectangular",
            theme: "outline",
            text: "signin_with",
            size: "large",
            locale: "en_US",
            width,
        });
    }

    const handleGoogleSignIn = async (res) => {
        if (!res.clientId || !res.credential) {
            return;
        }

        let sessionData = await ExceedApi.ssoLogin('GOOGLE', {
            idToken: res.credential,
            email: jwt_decode(res.credential).email,
        });

        handleLogin(sessionData);
    }

    useEffect(() => {
        if (gsiScriptLoaded) {
            return;
        }

        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.onload = initializeGsi;
        script.async = true;
        script.id = "google-client-script";
        document.querySelector("body")?.appendChild(script);
        console.log("appendChild");

        return () => {
            window.google?.accounts.id.cancel();
            document.getElementById("google-client-script")?.remove();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async () => {
        setLoginDisabled(true);
        let newErrors = [];

        if (!userName) {
            newErrors.push("Please enter email address");
        }

        if (!password) {
            newErrors.push("Please enter password");
        }

        if (newErrors.length === 0) {
            ExceedApi.login(userName, password)
                .then(sessionData => {
                    handleLogin(sessionData);
                })
                .catch(e => {
                    setErrors(["An incorrect username or password has been entered."]);
                    setLoginDisabled(false);
                });
        } else {
            setErrors(newErrors)
            setLoginDisabled(false);
        }

    }

    const handleLogin = async (sessionData) => {
        AppStore.setSessionData(sessionData);
        AppStore.setSessionStatus(SESSION_STATUS.ESTABLISHED);
        AppStore.setInitialDataStatus(SESSION_STATUS.ESTABLISHED)
        // TODO: Permissions?

        let redirectPath = '/';
        if (history.location && history.location.state) {
            const {from} = history.location.state;
            if (from) {
                redirectPath = from;
            }
        }

        history.push(redirectPath);
        setErrors([])
        setLoginDisabled(false);
    }
    const width = "175.188px";

    return <Page contentStyle={{display: "flex", flexDirection: "column", alignItems: "center"}} renderToolbar={() =>
        <Toolbar>
            <div className="left" style={{visibility: "hidden"}}>
            </div>
            <div className="center" style={{display: "flex", justifyContent: "center"}}>
                <img alt="Exceed.ai" src={logo} style={{height: "90%", maxWidth: "150px", maxHeight: "50px"}}/>
            </div>
            <div className="right" style={{visibility: "hidden"}}>
            </div>
        </Toolbar>}
                 renderBottomToolbar={() => <BottomToolbar modifier="material"> </BottomToolbar>}>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <p>
                <Input
                    style={{width: width}}
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    modifier='material'
                    float
                    placeholder='Username'/>
            </p>
            <p>
                <Input
                    style={{width: width}}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    modifier='material'
                    type='password'
                    float
                    placeholder='Password'/>
            </p>
            <div>
                <Button disabled={loginDisabled} onClick={handleSubmit} style={{width: width, textAlign: "center"}}>Log
                    in</Button>
            </div>
            <br/>
            <div id="google_sign_in_btn"></div> 
        </div>

        <AlertDialog isOpen={errors.length > 0}>
            <div className="alert-dialog-title">Login failed</div>
            <div className="alert-dialog-content">
                {errors[0]}
            </div>
            <div className="alert-dialog-footer">
                <Button onClick={() => setErrors([])} className="alert-dialog-button" modifier={"large"}>
                    Try again
                </Button>
            </div>
        </AlertDialog>
    </Page>
}